import { useState } from "react";
import { comicCategories, featuredComics, type ComicItem } from "@/mocks/comics";

export default function CategoryComics() {
  const [active, setActive] = useState<string>("全部");

  const list =
    active === "全部"
      ? featuredComics
      : featuredComics.filter((c) => c.category === active);

  return (
    <section id="comics" className="mx-auto max-w-page px-4 py-14 md:px-6 md:py-20">
      <div className="flex flex-col gap-6 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="inline-block rounded-full bg-primary-100 px-4 py-1.5 text-xs font-bold text-primary-700 md:text-sm">
            热门内容推荐
          </span>
          <h2 className="mt-4 font-heading text-2xl md:text-4xl">挑一部，今晚就看</h2>
          <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
            六大热门分类海量连载，点击分类即可快速切换，喜欢的作品随手追更。
          </p>
        </div>

        <div className="flex flex-wrap gap-2">
          {["全部", ...comicCategories.map((c) => c.name)].map((name) => (
            <button
              key={name}
              type="button"
              onClick={() => setActive(name)}
              className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                active === name
                  ? "bg-primary-500 text-background-50"
                  : "bg-secondary-100 text-foreground-700 hover:bg-primary-100 hover:text-primary-700"
              }`}
            >
              {name}
            </button>
          ))}
        </div>
      </div>

      <div className="mt-8 grid grid-cols-2 gap-4 md:mt-10 md:grid-cols-3 md:gap-6">
        {list.map((comic: ComicItem) => (
          <article
            key={comic.id}
            className="group overflow-hidden rounded-2xl border border-background-200 bg-background-50 transition-shadow hover:shadow-soft"
          >
            <div className="relative aspect-[3/4] overflow-hidden">
              <img
                src={comic.image}
                alt={`${comic.title} 漫画封面`}
                className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
              />
              {comic.badge && (
                <span className="absolute left-3 top-3 rounded-full bg-primary-500 px-3 py-1 text-xs font-bold text-background-50">
                  {comic.badge}
                </span>
              )}
              <span className="absolute right-3 top-3 rounded-full bg-background-950/60 px-2.5 py-1 text-xs font-medium text-background-50 backdrop-blur">
                {comic.tag}
              </span>
            </div>
            <div className="p-4 md:p-5">
              <div className="flex items-center justify-between gap-2">
                <h3 className="truncate text-sm font-bold md:text-base">{comic.title}</h3>
                <span className="flex items-center gap-1 whitespace-nowrap text-xs text-accent-700">
                  <i className="ri-star-fill"></i>
                  {comic.rating}
                </span>
              </div>
              <p className="mt-1 truncate text-xs text-foreground-600">
                作者 {comic.author} · {comic.chapters}话
              </p>
              <div className="mt-3 flex items-center justify-between">
                <span className="flex items-center gap-1 text-xs text-foreground-600">
                  <i className="ri-fire-line"></i>
                  {comic.views} 热度
                </span>
                <a
                  href="#entry"
                  className="inline-flex items-center gap-1 whitespace-nowrap rounded-full bg-primary-500 px-3.5 py-1.5 text-xs font-bold text-background-50 transition-colors hover:bg-primary-600"
                >
                  开始阅读
                </a>
              </div>
            </div>
          </article>
        ))}
      </div>

      <div className="mt-8 grid grid-cols-2 gap-4 md:grid-cols-3 md:gap-6">
        {comicCategories.map((cat) => (
          <div
            key={cat.id}
            className="flex items-center gap-3 rounded-2xl border border-background-200 bg-secondary-50 p-4"
          >
            <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-accent-100 text-accent-700">
              <i className={`${cat.icon} text-xl`}></i>
            </span>
            <div className="min-w-0">
              <h4 className="truncate text-sm font-bold">{cat.name}</h4>
              <p className="truncate text-xs text-foreground-600">{cat.desc}</p>
            </div>
            <span className="ml-auto whitespace-nowrap text-xs font-medium text-foreground-500">
              {cat.count}部
            </span>
          </div>
        ))}
      </div>
    </section>
  );
}